import { AppShell } from '@mantine/core'
import { type PageProps } from 'gatsby'
import React, { FC, useState } from 'react'

import SideMenu from './sideMenu'
import TopNavbar from './topnavbar'
import { Notifications } from '@mantine/notifications'
import { useAuth0 } from '@auth0/auth0-react'
import Loader from './loader'
import { Idle } from './Idle'
import { useLocalStorage } from '@mantine/hooks'

const NAVBAR_WIDTH = 220
// Icon (30px) plus the link's horizontal padding
const NAVBAR_COLLAPSED_WIDTH = 62

const Layout: FC<any> = ({ children }: PageProps) => {
  const [drawerState, setDrawerState] = useState(false)
  const { isLoading } = useAuth0()
  // Read on first render, so the navbar doesn't jump to the stored width
  const [navbarCollapsed, setNavbarCollapsed] = useLocalStorage({
    key: `navbar-collapsed`,
    defaultValue: false,
    getInitialValueInEffect: false,
  })

  if (isLoading) {
    return <Loader />
  }

  return (
    <AppShell
      padding="md"
      navbar={{
        width: navbarCollapsed ? NAVBAR_COLLAPSED_WIDTH : NAVBAR_WIDTH,
        breakpoint: 0,
        collapsed: { mobile: false },
      }}
      header={{ height: 52 }}
    >
      <TopNavbar drawerState={drawerState} toggleDrawer={setDrawerState} />
      <SideMenu
        collapsed={navbarCollapsed}
        onToggleCollapsed={() => setNavbarCollapsed((collapsed) => !collapsed)}
      />
      <AppShell.Main>
        {children}
        <Idle />
      </AppShell.Main>
      <Notifications position="bottom-right" pauseResetOnHover="notification" />
    </AppShell>
  )
}

export default Layout
